<template>
    <div>
        <Teleport to="#elePageTitle">
            {{ pagetitle }}
        </Teleport>
        <div class="row">
            <div class="col-12">
            <div class="card">
                <div class="card-header">
                <div class="row g-3 align-items-center">
                    <div class="col-lg-4 col-md-6">
                    <!-- Search input can be added here if needed -->
                    </div>
                    <div class="col-md-6 col-lg">
                    <div class="d-flex justify-content-end">
                        <!-- Add New button can be customized or removed based on requirements -->
                    </div>
                    </div>
                </div>
                <!-- end row -->
                </div>
                <div class="card-body">
                <div class="row">
                    <div class="col-lg-12">
                    <div class="table-responsive">
                        <table class="table mb-0">
                        <thead class="table-light">
                            <tr>
                            <th>File Name</th>
                            <th>Status</th>
                            <th v-if="showActionColumn()">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="loading">
                            <tr v-for="n in 5" :key="n">
                                <td v-for="m in showActionColumn() ? 3 : 2" :key="m" class="placeholder-glow">
                                <span class="placeholder col-12"></span>
                                </td>
                            </tr>
                            </template>
                            <template v-else-if="exportFiles.length">
                            <tr v-for="(file, index) in exportFiles" :key="index">
                                <td>{{ file.name }}</td>
                                <td>{{ file.status }}</td>
                                <td v-if="showActionColumn()">
                                <div class="d-flex gap-2">
                                    <button
                                    v-if="file.status === 'ready'"
                                    @click="downloadFile(file.name)"
                                    class="btn btn-primary bg-gradient btn-sm"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Download"
                                    >
                                    <i class="bx bx-download"></i>
                                    </button>
                                </div>
                                </td>
                            </tr>
                            </template>
                            <template v-else>
                            <tr>
                                <td colspan="3" class="text-center">No export files found</td>
                            </tr>
                            </template>
                        </tbody>
                        </table>
                    </div>
                    </div>
                </div>
                <!-- end row -->
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { defineComponent } from '@vue/composition-api'
import api from '@/api'

export default {
  data(){
    return{
        loading: true,
        pagetitle: 'Exports',
        exportList: [],
        baseUrl: `${window.apiUrl}/alerts/export/status/all`
    }
  },
  mounted(){
    this.fetchExportStatuses()
  },
   methods: {
        showActionColumn() {
            return true; 
        },
        fetchExportStatuses() {
            this.loading = true;
            api
                .get('/alerts/export/status/all')
                .then(response => {
                const statusMap = response.data;
                this.exportFiles = Object.entries(statusMap).map(([name, status]) => ({
                    name,
                    status
                }));
            })
            .catch(error => {
                console.error('Error fetching all export statuses:', error);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        downloadFile(name) {
            const params = { name };
            api
            .get('/alerts/export/file', { params, responseType: 'blob' })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch(error => {
                console.error('Error downloading file:', error);
            });
        },
        pollStatuses() {
            setInterval(() => {
            this.fetchExportStatuses();
            }, 5000); 
        }
    }  
}
</script>
